import { RiskItem } from 'src/app/api';
import { DeclarationState } from 'src/app/core/declaration.store';
import { QuotationSummaryResponse } from '../models/model/concretes/shared/quotation-summary.model';
import { format, parse } from 'date-fns';

// Fonction qui génère le RiskItems avec `store` passé en paramètre
function getRiskItems(store: any): Record<string, RiskItem> {
  const address = store.declaration().addressAutocomplete;

  return {
    PER: {
      order: 1,
      typeCode: 'PER',
      name: 'Personne',
      fields: {
        ADR_RISQUE:
          address?.streetNumber && address?.street
            ? `${address.streetNumber} ${address.street}`
            : address?.place,
        ADR_CODE_POSTAL: address?.postalCode,
        ADR_VILLE: address?.city
      }
    }
  };
}

// Fonction qui génère le DeclarationState avec `QuotationSummaryResponse` passé en paramètre
function getDeclarationStateFromQuotationSummary(
  quotationSummary: QuotationSummaryResponse
): DeclarationState {
  return {
    email: '',
    addressAutocomplete: null, // À définir selon le contexte
    address: quotationSummary.clientInformations.address1,
    postalCode: quotationSummary.clientInformations.zipCode,
    city: quotationSummary.clientInformations.addressCity,
    country: null, // À définir selon le contexte
    effect_date: format(
      parse(quotationSummary.requestedStartEffectiveDate, 'yyyy-MM-dd', new Date()),
      'dd/MM/yyyy HH:mm:ss'
    )
  };
}

export function getDeclarationState(quotationSummary: QuotationSummaryResponse): DeclarationState {
  return getDeclarationStateFromQuotationSummary(quotationSummary);
}

// Fonction qui retourne un RiskItem spécifique
export function getRiskItem(store: any, key: string): RiskItem | undefined {
  const riskItems = getRiskItems(store);
  return riskItems[key]; // Retourne l'objet si trouvé, sinon `undefined`
}
